import React, { useEffect, useRef, useState } from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteAppleSMSLink,
  importAppleSMSLink,
  loadAppleSMSLink,
} from "../../store/applesmslink/actions";
import AddNew from "./Global/AddNew";
import TableItem from "./Global/TableItem";

const AppleSMSLink = () => {
  const [modal_center, setmodal_center] = useState(false);
  const [editItem, setEditItem] = React.useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const applesmslink = useSelector((state) => state.APPLESMSLINK.applesmslink);
  const total = useSelector((state) => state.APPLESMSLINK.total);
  const dispatch = useDispatch();

  useEffect(() => {
    const timer = setTimeout(
      () => {
        dispatch(
          loadAppleSMSLink({
            page: currentPage,
            per_page: itemsPerPage,
            search: searchQuery,
            silent: currentPage > 1 || searchQuery.length > 0,
          })
        );
      },
      searchQuery ? 400 : 0
    );

    return () => clearTimeout(timer);
  }, [currentPage, searchQuery, dispatch]);

  const fileInputRef = useRef(null);

  document.title = "Apple SMS Link | Grpiraq ID";

  function tog_center() {
    setmodal_center(!modal_center);
    setEditItem({});
  }

  const handleEdit = (item) => {
    setEditItem(item);
    setmodal_center(!modal_center);
  };

  const handleDelete = (itemId) => {
    dispatch(deleteAppleSMSLink({ id: itemId }));
  };

  const handleSearch = (text) => {
    setSearchQuery(text.target.value);
    setCurrentPage(1);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      dispatch(importAppleSMSLink({ file }));
    }
    event.target.value = "";
  };

  const totalPages = Math.max(1, Math.ceil(total / itemsPerPage));

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = Math.min(totalPages, 10);
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    if (endPage - startPage < maxVisiblePages - 1) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
    return pageNumbers;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Grpiraq" breadcrumbItem="Apple SMS Link" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row className="g-4 mb-3">
                    <Col className="col-sm-auto">
                      <div className="d-flex gap-1">
                        <Button color="success" className="add-btn" onClick={tog_center}>
                          <i className="ri-add-line align-bottom me-1"></i> Add Apple SMS Link
                        </Button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileChange}
                        />
                        <Button
                          color="success"
                          className="add-btn"
                          onClick={() => fileInputRef.current.click()}
                        >
                          <i className="ri-arrow-down-line align-bottom me-1"></i> Import
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-sm">
                      <div className="d-flex justify-content-sm-end">
                        <div className="search-box ms-2">
                          <input
                            type="text"
                            className="form-control search"
                            placeholder="Search by ID, email or phone..."
                            value={searchQuery}
                            onChange={handleSearch}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <div className="table-responsive table-card mt-3 mb-1">
                    <table className="table align-middle table-nowrap">
                      <thead className="table-light">
                        <tr>
                          <th>ID</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Taken</th>
                          <th>Creation Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(Array.isArray(applesmslink) ? applesmslink : []).map((item) => (
                          <TableItem
                            key={item.id}
                            AppleSMSLink={item}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                          />
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-flex justify-content-center">
                    <div className="btn-group me-2">
                      <button
                        className="btn btn-primary"
                        onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
                        disabled={currentPage === 1}
                        type="button"
                      >
                        Previous
                      </button>
                      {getPageNumbers().map((pageNumber) => (
                        <button
                          type="button"
                          className="btn btn-primary"
                          key={pageNumber}
                          disabled={pageNumber === currentPage}
                          onClick={() => setCurrentPage(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      ))}
                      <button
                        className="btn btn-primary"
                        type="button"
                        disabled={currentPage === totalPages}
                        onClick={() =>
                          setCurrentPage((page) => Math.min(totalPages, page + 1))
                        }
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          {modal_center ? (
            <AddNew
              modal_center={modal_center}
              setmodal_center={setmodal_center}
              tog_center={tog_center}
              data={editItem}
            />
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default AppleSMSLink;
